"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableCardListWrapper = exports.Header = exports.Root = exports.classes = void 0;
const Box_1 = __importDefault(require("@mui/material/Box"));
const Paper_1 = require("@mui/material/Paper");
const styles_1 = require("@mui/material/styles");
const PREFIX = "ExpandableCard";
exports.classes = {
    collapsed: `${PREFIX}-collapsed`,
    expanded: `${PREFIX}-expanded`,
    icon: `${PREFIX}-icon`,
    title: `${PREFIX}-title`,
    titleStatic: `${PREFIX}-titleStatic`,
    close: `${PREFIX}-close`,
    body: `${PREFIX}-body`,
    footer: `${PREFIX}-footer`,
    content: `${PREFIX}-content`,
    expandableCardListCard: `${PREFIX}-expandableCardListCard`
};
const keyframes = {
    fade: `${PREFIX}-fade`
};
exports.Root = (0, styles_1.styled)(Box_1.default)(({ theme }) => ({
    zIndex: 1,
    minHeight: "56px",
    transition: "top 0.2s ease-out, right 0.2s ease-out, bottom 0.2s ease-out, left 0.2s ease-out, height 0.2s ease-out, box-shadow 0.2s ease-out",
    "&:focus": {
        outline: `${theme.colours.inter} 2px`
    },
    [theme.breakpoints.up("sm")]: {
        minHeight: "100%"
    },
    [theme.breakpoints.down("sm")]: {
        [`&, &:hover .${Paper_1.paperClasses.root}`]: {
            background: "transparent",
            boxShadow: "none"
        }
    },
    [`&.${exports.classes.collapsed}`]: {
        cursor: "pointer",
        "&:hover": {
            [`.${exports.classes.title}`]: {
                color: theme.colours.charcoal
            },
            [`.${exports.classes.icon}`]: {
                color: theme.colours.inter
            }
        },
        [`.${exports.classes.content}`]: {
            padding: "16px"
        },
        [theme.breakpoints.up("sm")]: {
            "&:hover": {
                boxShadow: "0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)"
            },
            [`.${exports.classes.content}`]: {
                padding: "24px 20px"
            }
        }
    },
    [`&.${exports.classes.expanded}`]: {
        zIndex: 2,
        position: "absolute",
        minHeight: "auto",
        top: 0,
        right: 0,
        left: 0,
        background: theme.colours.white,
        boxShadow: "0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
        "&:hover": {
            background: theme.colours.white,
            boxShadow: "0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)"
        },
        transition: "right 0.25s ease-in-out, left 0.25s ease-in-out, box-shadow 0.25s ease-in-out, height 0.25s ease-in-out, top 0.25s 0.2s ease-out, bottom 0.25s 0.2s ease-out",
        [`.${exports.classes.content}`]: {
            padding: "20px"
        },
        [`.${exports.classes.icon}`]: {
            left: 0,
            width: "36px",
            height: "36px"
        },
        [`.${exports.classes.title}`]: {
            marginTop: 0,
            top: "6px",
            left: "calc(16px + 36px)",
            right: "100%",
            transform: "translateX(0)"
        },
        [`.${exports.classes.close}`]: {
            display: "block",
            animation: `${keyframes.fade} 0.25s 0.2s ease-out both`
        },
        [`.${exports.classes.footer}`]: {
            display: "block",
            animation: `${keyframes.fade} 0.25s 0.2s ease-out both`
        },
        [`.${exports.classes.body}`]: {
            display: "block",
            animation: `${keyframes.fade} 0.25s 0.2s ease-out both`
        }
    },
    [`.${exports.classes.icon}`]: {
        width: "24px",
        height: "24px",
        marginRight: "16px",
        color: theme.colours.accent,
        transition: "color 280ms cubic-bezier(0.4, 0, 0.2, 1), height 0.2s ease-in-out, width 0.2s ease-in-out, top 0.2s ease-in-out, left 0.2s ease-in-out",
        [theme.breakpoints.up("sm")]: {
            position: "absolute",
            width: "72px",
            height: "72px",
            top: 0,
            left: "calc(50% - 72px / 2)"
        }
    },
    [`.${exports.classes.title}`]: {
        textTransform: "none",
        color: theme.colours.slate,
        transition: "color 280ms cubic-bezier(0.4, 0, 0.2, 1), top 0.2s ease-in-out, right 0.2s ease-in-out, left 0.2s ease-in-out",
        [theme.breakpoints.up("sm")]: {
            position: "absolute",
            top: "calc(72px + 24px)",
            left: 0,
            whiteSpace: "nowrap",
            textAlign: "center",
            right: 0
        }
    },
    [`.${exports.classes.titleStatic}`]: {
        [theme.breakpoints.up("sm")]: {
            position: "static",
            marginTop: "calc(72px + 24px)",
            whiteSpace: "inherit"
        }
    },
    [`.${exports.classes.close}`]: {
        position: "absolute",
        top: "6px",
        right: "6px",
        zIndex: 3,
        color: theme.colours.slate,
        opacity: 0,
        display: "none"
    },
    [`.${exports.classes.body}`]: {
        marginTop: "19px",
        borderTop: `1px solid ${theme.colours.storm}`,
        paddingTop: "20px",
        opacity: 0,
        display: "none"
    },
    [`.${exports.classes.footer}`]: {
        marginTop: "auto",
        borderTop: `1px solid ${theme.colours.storm}`,
        paddingTop: "20px",
        opacity: 0,
        display: "none"
    },
    [`@keyframes ${keyframes.fade}`]: {
        "0%": {
            opacity: 0
        },
        "100%": {
            opacity: 1
        }
    },
    [`.${exports.classes.content}`]: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        minHeight: "100%",
        transition: "padding 0.2s ease-in-out"
    }
}));
exports.Header = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    minHeight: "36px",
    position: "relative",
    paddingRight: "calc(48px / 2 + 6px)",
    [theme.breakpoints.up("sm")]: {
        justifyContent: "center",
        paddingRight: 0
    }
}));
exports.ExpandableCardListWrapper = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "flex",
    position: "relative",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.up("sm")]: {
        margin: "-10px",
        flexWrap: "wrap",
        flexDirection: "row"
    },
    [`.${exports.classes.expandableCardListCard}`]: {
        [theme.breakpoints.up("sm")]: {
            flex: "1 0 21%",
            margin: "10px"
        }
    }
}));
//# sourceMappingURL=data:application/json;base64,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